
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomCard from '../../common/CustomCard';
import StatusChip from '../../common/StatusChip';

const useStyles = makeStyles(() => ({
  studentCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 56,
    height: 'auto',
    marginBottom: 5
  },
  listContainer: {
    maxHeight: 300,
    overflowY: 'auto',
    paddingRight: 4,
    // Custom scrollbar styling
    '&::-webkit-scrollbar': {
      width: 6
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#512EAB26',
      borderRadius: 3
    },
    '&::-webkit-scrollbar-button': {
      display: 'none !important',
      width: '0 !important',
      height: '0 !important'
    },
    scrollbarWidth: 'thin',
    scrollbarColor: '#512EAB26 transparent'
  },
  studentName: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#333'
  }
}));

const StudentStatusList = ({ students }) => {
  const classes = useStyles();

  return (
    <Box className={classes.listContainer}>
      {students.map((student, index) => (
        <CustomCard
          key={index}
          backgroundColor="#F6F6FB"
          className={classes.studentCard}
        >
          <Typography className={classes.studentName}>
            {student.name}
          </Typography>
          <StatusChip
            status={student.status}
            size="small"
          />
        </CustomCard>
      ))}
    </Box>
  );
};

StudentStatusList.propTypes = {
  students: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired
    })
  ).isRequired
};

export default StudentStatusList;
